// extracted by mini-css-extract-plugin
export default {"container":"ProjectHeader_container__VmXje","careRecipient":"ProjectHeader_careRecipient__ba9KA","project":"ProjectHeader_project__yKcTz"};